import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import exportJsonExcel from "js-export-excel";
import SelectDropDown from "../../../partials/content/SelectDropDown";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import Pagination from "./Pagination";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";

function ManageSitePublisher() {
  const [categories, setCategories] = useState([]);
  const [sitesPublisher, setSitesPublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();
  const [siteNameSearchFilter, setSiteNameSearchFilter] = useState();
  const [activeSite, setActiveSite] = useState(false);

  useEffect(() => {
    if (categories.length > 0) {
      return;
    }
    getCategories();
  }, []);

  useEffect(() => {
    getSitePublishers();
  }, [currentPage, categoryNameSearchFilter, siteNameSearchFilter, activeSite]);

  const getCategories = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetCategories();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categories) {
      return;
    }

    setCategories(
      categories.map((category) => {
        return { value: category.cas_id, label: category.cas_name };
      })
    );
  };

  const sendRequestGetCategories = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const getSitePublishers = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitesPublisher = await sendRequestGetSitesPublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!sitesPublisher) {
      return;
    }

    setSitesPublisher(sitesPublisher.data);
    setCountPage(sitesPublisher.total_page);
  };

  const sendRequestGetSitesPublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let sitePublishers;
    try {
      sitePublishers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/site-publishers?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error);
      return false;
    }
    return sitePublishers.data.data;
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (siteNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&site=${siteNameSearchFilter}`;
    }
    if (categoryNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&category=${categoryNameSearchFilter}`;
    }
    if (activeSite) {
      searchFilterQuery = `${searchFilterQuery}&active_site=true`;
    }

    return searchFilterQuery;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getStatusCheckBoxActiveSite = () => {
    return document.getElementById("check-active-site").checked;
  };

  const generateBodyTableSitePublisher = () => {
    let classTrTag = "";
    let classBtnEdit = "btn-primary";
    let classBtnRemove = "btn-danger";

    return (
      <>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td className={classTrTag}>#</td>
                <td className={classTrTag}>شماره سایت نمایش دهنده</td>
                <td className={classTrTag}>اولویت</td>
                <td className={classTrTag}>نمایش دهنده</td>
                <td className={classTrTag}>دسته بندی موضوع</td>
                <td className={classTrTag}>نوع تبلیغ</td>
                <td className={classTrTag}>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {sitesPublisher.map((sitePublisher, index) => {
                if (getStatusCheckBoxActiveSite()) {
                  if (sitePublisher.active) {
                    classTrTag = "bg-success";
                  } else {
                    classTrTag = "bg-danger";
                  }

                  classBtnEdit = "btn-primary";
                  classBtnRemove = "btn-warning";
                }

                return (
                  <tr key={index}>
                    <td className={classTrTag}>
                      {helperNumbers.toPersianNum(index + 1)}
                    </td>
                    <td className={classTrTag}>
                      {helperNumbers.toPersianNum(sitePublisher.id)}
                    </td>
                    <td className={classTrTag}>
                      {helperNumbers.toPersianNum(sitePublisher.priority)}
                    </td>
                    <td className={classTrTag}>
                      <a href={sitePublisher.url} target="_blank">
                        {sitePublisher.url}
                      </a>
                    </td>
                    <td className={classTrTag}>
                      {sitePublisher.categories.join(" - ")}
                    </td>
                    <td className={classTrTag}>
                      {sitePublisher.advertise.join(" - ")}
                    </td>
                    <td className={classTrTag}>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/manage/publishers/edit/${sitePublisher.id}`}
                            className={`btn ${classBtnEdit} `}
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </span>

                        {/* <span>
                <span
                  className={`btn ${classBtnRemove} `}
                  onClick={() => {
                    deleteSitePublisher(sitePublisher.id);
                  }}
                >
                  <i className="fa fa-trash"></i>
                </span>
              </span> */}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const showSelectCategorySitePublisher = () => {
    const categoriesForSelectDropDown = [
      { value: 0, label: "همه دسته ها" },
      ...categories,
    ];

    return (
      <SelectDropDown
        data={categoriesForSelectDropDown}
        setItemHandler={(newItemSelected) => {
          if (!newItemSelected.value) {
            setCategoryNameSearchFilter();
            return;
          }
          setCategoryNameSearchFilter(newItemSelected.label);
        }}
      />
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="manage-publisher"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  مدیریت سایت های نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <Link className="btn btn-info mb-2" to="/manage/publishers/add">
                <span className="pl-2">
                  <i className="fa fa-plus"></i>
                </span>
                <span>اضافه کردن سایت نمایش دهنده</span>
              </Link>

              <div className="container-fluid py-2">
                <div className="alert alert-info">
                  <span className="pl-2">
                    <i className="fa fa-info"></i>
                  </span>
                  <span>
                    هنگام فعال کردن بررسی فعال بودن سایت باید چند ثانیه صبر کنید
                  </span>
                </div>
                <div className="row alert alert-secondary">
                  <div className="col-12 col-md-4 ">
                    <label>جستجو آدرس سایت</label>
                    <input
                      onKeyUp={(e) => {
                        setSiteNameSearchFilter(e.target.value);
                      }}
                      type="text"
                      id="site"
                      className="form-control"
                      placeholder="http://monirlock.ir/"
                    />
                  </div>
                  <div className="col-12 col-md-4 ">
                    <label>دسته های صنفی</label>
                    {categories.length > 0 && showSelectCategorySitePublisher()}
                  </div>
                  <div className="col-12 col-md-4 ">
                    <label> بررسی بالا بودن سایت</label>
                    <div>
                      <label class="adl-switch">
                        <input
                          type="checkbox"
                          id="check-active-site"
                          onChange={() => {
                            setActiveSite((prevState) => !prevState);
                          }}
                        />
                        <span class="adl-slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {sitesPublisher.length > 0 && generateBodyTableSitePublisher()}

              <span className="pl-2">
                <div className="btn btn-success">
                  <span className="pl-2">
                    <i className="fa fa-file-excel-o"></i>
                  </span>
                  <span>خروجی فایل Excel</span>
                </div>
              </span>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ManageSitePublisher;
